import React, { Component, ReactNode } from 'react';
import { UnauthorizedAccess } from './unauthorizedError';

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

export class ErrorBoundaryCustom extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    // You can also send this to a logging service
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            textAlign: 'center',
            padding: '2rem'
          }}
        >
          {this.state.error &&
            this.state.error.message !== 'unauthorizedForDocument' && (
              <pre style={{ color: '#d00', whiteSpace: 'pre-wrap' }}>
                <h2>Something went wrong.</h2>
                {this.state.error.message}
              </pre>
            )}
          {this.state.error?.message === 'unauthorizedForDocument' && (
            <UnauthorizedAccess />
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
